import { useMemo } from 'react';
import { ADMIN_NAV_ITEMS, type NavItem } from '@/config/navigation';
// import { useAuth } from '@/app/providers';

/**
 * Hook to get filtered navigation items based on user permissions.
 *
 * Currently returns all items since permissions are not implemented.
 * When permissions are added, uncomment the useAuth import and filtering logic.
 */
export function useNavigation(): NavItem[] {
  // const { user } = useAuth();

  return useMemo(() => {
    // When permissions are implemented, filter like this:
    // return ADMIN_NAV_ITEMS.filter(
    //   (item) => !item.permission || user?.permissions?.includes(item.permission)
    // );

    // For now, return all items
    return ADMIN_NAV_ITEMS;
  }, []);
}
